import { EMAIL_REGEX } from '@kentik/ui-shared/util/regex';

// Enhanced email validation for emails to prevent phishing
const isEmailSafe = (value) => {
  if (!value) {
    return true;
  } // Allow empty values

  // First check if it's a valid email format using the same regex as the base email validator
  if (!value.match(EMAIL_REGEX)) {
    return false;
  }

  const email = value.toLowerCase().trim();

  // Check for suspicious TLDs commonly used in phishing
  const suspiciousTlds = [
    '.tk',
    '.ml',
    '.ga',
    '.cf',
    '.gq', // Free domains often used for phishing
    '.bit',
    '.onion', // Non-standard domains
    '.temp',
    '.tempmail',
    '.guerrillamail' // Temporary email services
  ];

  if (suspiciousTlds.some((tld) => email.endsWith(tld))) {
    return false;
  }

  // Check for homograph attacks (lookalike characters)
  const dangerousChars = /[а-я]|[α-ω]|[а-я]|[\u0400-\u04FF]|[\u0370-\u03FF]|[\u4e00-\u9fff]/;
  if (dangerousChars.test(email)) {
    return false;
  }

  // Check for suspicious patterns in email addresses
  const suspiciousPatterns = [
    /no-?reply/i,
    /do-?not-?reply/i,
    /noreply/i,
    /security.*alert/i,
    /urgent/i,
    /verification.*required/i,
    /no\.reply/i,
    /donot\.reply/i,
    /securityalert/i
  ];

  const localPart = email.split('@')[0];
  if (suspiciousPatterns.some((pattern) => pattern.test(localPart))) {
    return false;
  }

  return true;
};

export default {
  fn: isEmailSafe,
  message: 'Please provide a valid email address from a trusted domain'
};
